import Chart from 'chart.js'
import Chartkick from 'chartkick'

Chartkick.use(Chart)

export { Chartkick }
